@if (column()) {
    @if (column().fieldType === CellType.text) {
        <!-- NOTE: IF THE ENGLISH NAME IS NULL THEN USE THE ARABIC NAME -->
        @if (column().fieldName === "nameEN" && !AdaaHelper.isDefinedAndNotEmpty(data()[column().fieldName])) {
            {{ data()["nameAE"] }}
        } @else {
            {{ data()[column().fieldName] }}
        }
    } @else if (column().fieldType === CellType.trasnlatableText) {
        @if (column().fieldName === "nameEN" && !AdaaHelper.isDefinedAndNotEmpty(data()[column().fieldName])) {
            {{ translatedTextMap()?.["translatedCell"] ?? data()["nameAE"] }}
            <adaa-translation
                [type]="'translatedCell'"
                [originalText]="data()['nameAE']"
                (translationDone)="onTranslationDone($event.type, $event.text)"
            ></adaa-translation>
        } @else {
            {{ translatedTextMap()?.["translatedCell"] ?? data()[column().fieldName] }}
            <adaa-translation
                [type]="'translatedCell'"
                [originalText]="data()[column().fieldName]"
                (translationDone)="onTranslationDone($event.type, $event.text)"
            ></adaa-translation>
        }
    } @else if (column().fieldType === CellType.date) {
        {{ data()[column().fieldName] | date: Constants.normalDate : Constants.uaeTimezone }}
    } @else if (column().fieldType === CellType.datetime) {
        {{ data()[column().fieldName] | date: Constants.dateTime : Constants.uaeTimezone }}
    } @else if (column().fieldType === CellType.trueFalse) {
        <div class="flex-center">
            <input [checked]="data()[column().fieldName]" class="form-check-input" type="checkbox" disabled />
        </div>
    } @else if (column().fieldType === CellType.checkbox) {
        <!--[checked] prop will not work without a form-->
        <input
            [checked]="isCheckboxChecked()"
            [disabled]="isInputDisabled()"
            class="form-check-input"
            type="checkbox"
            (change)="checkboxValueChanged($event, column().fieldName)"
        />
    } @else if (column().fieldType === CellType.dropdown) {
        <ng-select
            [items]="getDdlOptions()"
            bindLabel="text"
            bindValue="value"
            [clearable]="isClearable()"
            [disabled]="isInputDisabled()"
            [dir]="languageService.direction()"
            appendTo="body"
            [(ngModel)]="data()[column().fieldName]"
            (ngModelChange)="dropdownValueChanged($event, column().fieldName)"
        >
            <ng-template ng-option-tmp let-item="item">
                <div [dir]="languageService.direction()">{{ item.text }}</div>
            </ng-template>
        </ng-select>
    } @else if (column().fieldType === CellType.status) {
        @if (data()[column().fieldName] === 1) {
            {{ "status.1" | translate }}
        } @else if (data()[column().fieldName] === 2) {
            {{ "status.2" | translate }}
        } @else if (data()[column().fieldName] === 3) {
            {{ "status.3" | translate }}
        } @else if (data()[column().fieldName] === 4) {
            {{ "status.4" | translate }}
        } @else if (data()[column().fieldName] === 5) {
            {{ "status.5" | translate }}
        } @else if (data()[column().fieldName] === 6) {
            {{ "status.6" | translate }}
        } @else if (data()[column().fieldName] === 7) {
            {{ "status.in_review" | translate }}
        }
    } @else if (column().fieldType === CellType.agreementStatus) {
        @if (data()[column().fieldName] === Constants.OBJECT_STATUS.ACTIVE) {
            {{ "published" | translate }}
        } @else if (data()[column().fieldName] === Constants.OBJECT_STATUS.DRAFT) {
            {{ "status.3" | translate }}
        } @else if (data()[column().fieldName] === Constants.OBJECT_STATUS.IN_REVIEW) {
            {{ "status.in_review" | translate }}
        }
    } @else if (column().fieldType === CellType.trend) {
        @if (data()[column().fieldName] === Constants.TREND.INCREASING) {
            <span class="adaa-icon-increasing trend"> </span>
        } @else if (data()[column().fieldName] === Constants.TREND.DECREASING) {
            <span class="adaa-icon-decreasing trend"></span>
        } @else if (data()[column().fieldName] === Constants.TREND.ONTARGET) {
            <span class="adaa-icon-ontarget trend"></span>
        } @else if (data()[column().fieldName] === Constants.TREND.BOUNDED) {
            <span class="adaa-icon-bounded trend"></span>
        }
    } @else if (column().fieldType === CellType.metric) {
        @if (data()[column().fieldName] === Constants.METRICS_TYPE.GLOBAL) {
            {{ "main_types.G" | translate }}
        } @else if (data()[column().fieldName] === Constants.METRICS_TYPE.LOCAL) {
            {{ "main_types.L" | translate }}
        } @else if (data()[column().fieldName] === Constants.METRICS_TYPE.LOCAL_ALL) {
            {{ "main_types.LA" | translate }}
        } @else if (data()[column().fieldName] === Constants.METRICS_TYPE.DIMENSION) {
            {{ "main_types.D" | translate }}
        }
    } @else if (column().fieldType === CellType.rules) {
        @if (data()[column().fieldName] === Constants.RULE_STATUS.INACTIVE) {
            {{ "common.form.label.inactive" | translate }}
        } @else if (data()[column().fieldName] === Constants.RULE_STATUS.ACTIVE) {
            {{ "common.form.label.active" | translate }}
        }
    } @else if (column().fieldType === CellType.workflow) {
        @if (data()[column().fieldName] === Constants.CONSTANT_WORKFLOW_WFTYPES.APPROVAL) {
            {{ "workflow.approval" | translate }}
        } @else if (data()[column().fieldName] === Constants.CONSTANT_WORKFLOW_WFTYPES.REVIEW) {
            {{ "workflow.review" | translate }}
        }
    } @else if (column().fieldType === CellType.yesNo) {
        @if (data()[column().fieldName] === AdaaBoolean.Y) {
            {{ "common.form.label.yes" | translate }}
        } @else {
            {{ "common.form.label.no" | translate }}
        }
    } @else if (column().fieldType === CellType.percentage) {
        <span class="badge rounded-1" [style.background]="getPercentageColor()">
            @if (AdaaHelper.isDefined(data()[column().fieldName])) {
                {{ data()[column().fieldName] | percentageValue: 2 : "" }}
            }
        </span>
    } @else if (column().fieldType === CellType.percentagePeriod) {
        @if (data()["hasPeriodReading"] === null || data()["hasPeriodReading"] === true) {
            <span class="badge rounded-1" [style.background]="getPercentageColor()">
                @if (AdaaHelper.isDefined(data()[column().fieldName])) {
                    {{ data()[column().fieldName] | percentageValue: 2 : "" }}
                }
            </span>
        } @else if (data()["hasPeriodReading"] === false) {
            {{ "kpi.no_period" | translate }}
        }
    } @else if (column().fieldType === CellType.enabled) {
        @if (data()[column().fieldName] === AdaaBoolean.Y) {
            {{ "common.form.label.active" | translate }}
        } @else {
            {{ "common.form.label.inactive" | translate }}
        }
    } @else if (column().fieldType === CellType.html) {
        <span [innerHTML]="data()[column().fieldName] | safeHtml"></span>
    } @else if (column().fieldType === CellType.actual) {
        @if (data()["ignored"]) {
            N/A
        } @else {
            @if (data()["measurementUnit"] === Constants.MEASUREMENT.PERCENTAGE) {
                {{ getNumberValue(column().fieldName) | percentageValue: 2 : "" : "%" : true : true }}
            } @else {
                {{ getNumberValue(column().fieldName) | roundValue: 2 : "" : true }}
            }
        }
    } @else if (column().fieldType === CellType.specialCase) {
        <adaa-data-table-cell-special [data]="data()" [column]="column()" [configKey]="configKey()"></adaa-data-table-cell-special>
    }
}
